export default __webpack_public_path__ + "static/media/05.8e9f41de.jpg";